import { type FunctionComponent } from "react";

import { Container, ItemName, Logo, LogoWrapper } from "./styles";

type Props = {
  icon: string;
  name: string;
  onClick?: () => void;
};

export const IndustryListItem: FunctionComponent<Props> = ({ icon, name, onClick }) => (
  <Container onClick={onClick}>
    <LogoWrapper>
      <Logo alt={name} src={icon} />
    </LogoWrapper>
    <ItemName>{name}</ItemName>
  </Container>
);

IndustryListItem.displayName = "IndustryListItem";
